export const roleColors: Record<string, { color: string; backgroundColor: string }> = {
  User: { color: '#1e88e5', backgroundColor: '#e3f2fd' },
  Пользователь: { color: '#1e88e5', backgroundColor: '#e3f2fd' },

  HumanResources: { color: '#6a1b9a', backgroundColor: '#f3e5f5' },
  HR: { color: '#6a1b9a', backgroundColor: '#f3e5f5' },
  Кадровик: { color: '#6a1b9a', backgroundColor: '#f3e5f5' },
  'Руководитель кадровой службы': { color: '#6a1b9a', backgroundColor: '#f3e5f5' },

  Accountant: { color: '#2e7d32', backgroundColor: '#e8f5e9' },
  Бухгалтер: { color: '#2e7d32', backgroundColor: '#e8f5e9' },
  'Главный бухгалтер': { color: '#2e7d32', backgroundColor: '#e8f5e9' },

  ResourceManager: { color: '#ef6c00', backgroundColor: '#fff3e0' },
  МенеджерРесурсов: { color: '#ef6c00', backgroundColor: '#fff3e0' },
  Менеджер: { color: '#ef6c00', backgroundColor: '#fff3e0' },
  'Ресурсный менеджер': { color: '#ef6c00', backgroundColor: '#fff3e0' },

  Recruiter: { color: '#c62828', backgroundColor: '#ffebee' },
  Рекрутер: { color: '#c62828', backgroundColor: '#ffebee' },
  Рекрутёр: { color: '#c62828', backgroundColor: '#ffebee' },

  Administrator: { color: '#1e88e5', backgroundColor: '#e3f2fd' },
  Администратор: { color: '#1e88e5', backgroundColor: '#e3f2fd' },

  Guest: { color: '#757575', backgroundColor: '#f5f5f5' },
  Гость: { color: '#757575', backgroundColor: '#f5f5f5' },

  CEO: { color: '#6a1b9a', backgroundColor: '#f3e5f5' },
  'Генеральный директор': { color: '#6a1b9a', backgroundColor: '#f3e5f5' },

  ProjectManager: { color: '#ef6c00', backgroundColor: '#fff3e0' },
  'Проектный менеджер': { color: '#ef6c00', backgroundColor: '#fff3e0' },

  Interviewer: { color: '#1e88e5', backgroundColor: '#e3f2fd' },
  Интервьювер: { color: '#1e88e5', backgroundColor: '#e3f2fd' },
};